import { Hero } from "@/components/home/Hero";
import { Manifesto } from "@/components/home/Manifesto";
import { Pillars } from "@/components/home/Pillars";
import { Bento } from "@/components/home/Bento";
import { Work } from "@/components/home/Work";
import { Process } from "@/components/home/Process";
import { Marquee } from "@/components/site/Marquee";
import { CTA } from "@/components/site/CTA";
import { MARQUEE } from "@/lib/content";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee items={MARQUEE} testid="home-marquee" />
      <Manifesto />
      <Pillars />
      <Bento />
      <Work />
      <Process />
      <CTA />
    </main>
  );
}
